import {
  VolumeDown,
  VolumeMute,
  VolumeOff,
  VolumeUp,
} from "@mui/icons-material"
import { VOLUME_MARKS } from "../pages/Home/Instruments/Instruments"

const ICON_SIZE = "55%"

export const VolumeIcon = ({ value }: { value: number }) => {
  if (value === VOLUME_MARKS[0].value) {
    return <VolumeOff sx={{ width: ICON_SIZE }}/>
  }
  if (value === VOLUME_MARKS[1].value) {
    return <VolumeMute sx={{ width: ICON_SIZE }} />
  }
  if (value === VOLUME_MARKS[2].value) {
    return <VolumeDown sx={{ width: ICON_SIZE }}/>
  }
  if (value >= VOLUME_MARKS[3].value) {
    return <VolumeUp sx={{ width: ICON_SIZE }}/>
  } else {
    return <VolumeDown sx={{ width: ICON_SIZE }}/>
  }
}
